"use client";

import { c as _c } from "react/compiler-runtime";
import AutoHeightPlugin from "embla-carousel-auto-height";
import AutoplayPlugin from "embla-carousel-autoplay";
import ClassNamesPlugin from "embla-carousel-class-names";
import useEmblaCarousel from "embla-carousel-react";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useContextSelector } from "use-context-selector";
import { classNames } from "../../utils/classNames";
import { Block } from "../Block";
import { CarouselContext } from "./CarouselProvider";
import { getCarouselOptions } from "./utils";
function Carousel(t0) {
  const $ = _c(67);
  let animateHeight;
  let autoHeight;
  let autoplay;
  let autoplayOptions;
  let children;
  let className;
  let disableWheelScrolling;
  let onScroll;
  let options;
  let props;
  let setApi;
  if ($[0] !== t0) {
    ({
      animateHeight,
      autoplay,
      autoplayOptions,
      autoHeight,
      children,
      className,
      disableWheelScrolling,
      options,
      setApi,
      onScroll,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = animateHeight;
    $[2] = autoHeight;
    $[3] = autoplay;
    $[4] = autoplayOptions;
    $[5] = children;
    $[6] = className;
    $[7] = disableWheelScrolling;
    $[8] = onScroll;
    $[9] = options;
    $[10] = props;
    $[11] = setApi;
  } else {
    animateHeight = $[1];
    autoHeight = $[2];
    autoplay = $[3];
    autoplayOptions = $[4];
    children = $[5];
    className = $[6];
    disableWheelScrolling = $[7];
    onScroll = $[8];
    options = $[9];
    props = $[10];
    setApi = $[11];
  }
  let t1;
  if ($[12] !== options) {
    t1 = options ? getCarouselOptions(options) : {};
    $[12] = options;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== t1) {
    t2 = {
      inViewThreshold: 0.9,
      ...t1
    };
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ClassNamesPlugin();
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== autoplay || $[18] !== autoplayOptions) {
    t4 = autoplay ? AutoplayPlugin({
      rootNode: _temp,
      ...autoplayOptions
    }) : null;
    $[17] = autoplay;
    $[18] = autoplayOptions;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== autoHeight) {
    t5 = autoHeight ? AutoHeightPlugin() : null;
    $[20] = autoHeight;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== disableWheelScrolling) {
    t6 = disableWheelScrolling ? null : WheelGesturesPlugin();
    $[22] = disableWheelScrolling;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = [t3, t4, t5, t6].filter(Boolean);
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  const [carouselRef, api] = useEmblaCarousel(t2, t7);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [navigationApi, setNavigationApi] = useState();
  let t8;
  if ($[28] !== navigationApi || $[29] !== onScroll) {
    t8 = api_0 => {
      if (navigationApi) {
        navigationApi.scrollTo(api_0.selectedScrollSnap());
      }
      const apiIndex = api_0.selectedScrollSnap();
      const apiCanScrollPrev = api_0.canScrollPrev();
      const apiCanScrollNext = api_0.canScrollNext();
      setSelectedIndex(apiIndex);
      setCanScrollPrev(apiCanScrollPrev);
      setCanScrollNext(apiCanScrollNext);
      onScroll?.({
        index: apiIndex,
        canScrollPrev: apiCanScrollPrev,
        canScrollNext: apiCanScrollNext
      });
    };
    $[28] = navigationApi;
    $[29] = onScroll;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  const onSelect = t8;
  let t9;
  if ($[31] !== api) {
    t9 = () => {
      api?.plugins().autoplay?.stop();
      api?.scrollPrev();
    };
    $[31] = api;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  const scrollPrev = t9;
  let t10;
  if ($[33] !== api) {
    t10 = () => {
      api?.plugins().autoplay?.stop();
      api?.scrollNext();
    };
    $[33] = api;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  const scrollNext = t10;
  let t11;
  if ($[35] !== api) {
    t11 = (...t12) => {
      const options_0 = t12;
      api?.plugins().autoplay?.stop();
      api?.scrollTo(...options_0);
    };
    $[35] = api;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  const scrollTo = t11;
  let t12;
  let t13;
  if ($[37] !== api || $[38] !== setApi) {
    t12 = () => {
      if (!(api && setApi)) {
        return;
      }
      setApi(api);
    };
    t13 = [api, setApi];
    $[37] = api;
    $[38] = setApi;
    $[39] = t12;
    $[40] = t13;
  } else {
    t12 = $[39];
    t13 = $[40];
  }
  useEffect(t12, t13);
  let t14;
  let t15;
  if ($[41] !== api || $[42] !== onSelect) {
    t14 = () => {
      if (!api) {
        return;
      }
      onSelect(api);
      api.on("reInit", onSelect);
      api.on("select", onSelect);
      return () => {
        api?.off("select", onSelect);
        api?.off("reInit", onSelect);
      };
    };
    t15 = [api, onSelect];
    $[41] = api;
    $[42] = onSelect;
    $[43] = t14;
    $[44] = t15;
  } else {
    t14 = $[43];
    t15 = $[44];
  }
  useEffect(t14, t15);
  let t16;
  let t17;
  if ($[45] !== animateHeight || $[46] !== api || $[47] !== autoHeight || $[48] !== canScrollNext || $[49] !== canScrollPrev || $[50] !== carouselRef || $[51] !== navigationApi || $[52] !== options || $[53] !== scrollNext || $[54] !== scrollPrev || $[55] !== scrollTo || $[56] !== selectedIndex) {
    t17 = {
      carouselRef,
      api,
      autoHeight,
      animateHeight,
      options,
      scrollPrev,
      scrollNext,
      canScrollPrev,
      canScrollNext,
      navigationApi,
      setNavigationApi,
      scrollTo,
      selectedIndex
    };
    $[45] = animateHeight;
    $[46] = api;
    $[47] = autoHeight;
    $[48] = canScrollNext;
    $[49] = canScrollPrev;
    $[50] = carouselRef;
    $[51] = navigationApi;
    $[52] = options;
    $[53] = scrollNext;
    $[54] = scrollPrev;
    $[55] = scrollTo;
    $[56] = selectedIndex;
    $[57] = t17;
  } else {
    t17 = $[57];
  }
  t16 = t17;
  const value = t16;
  let t18;
  if ($[58] !== className) {
    t18 = classNames("group/carousel relative", className);
    $[58] = className;
    $[59] = t18;
  } else {
    t18 = $[59];
  }
  let t19;
  if ($[60] !== children || $[61] !== props || $[62] !== t18) {
    t19 = <Block aria-roledescription="carousel" className={t18} role="region" {...props}>{children}</Block>;
    $[60] = children;
    $[61] = props;
    $[62] = t18;
    $[63] = t19;
  } else {
    t19 = $[63];
  }
  let t20;
  if ($[64] !== t19 || $[65] !== value) {
    t20 = <CarouselContext.Provider value={value}>{t19}</CarouselContext.Provider>;
    $[64] = t19;
    $[65] = value;
    $[66] = t20;
  } else {
    t20 = $[66];
  }
  return t20;
}
function _temp(carouselRoot) {
  return carouselRoot;
}
export function CarouselContent(t0) {
  const $ = _c(18);
  let allowOverflow;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      allowOverflow,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = allowOverflow;
    $[2] = className;
    $[3] = props;
  } else {
    allowOverflow = $[1];
    className = $[2];
    props = $[3];
  }
  const [autoHeight, animateHeight, carouselRef, loop] = useContextSelector(CarouselContext, _temp2);
  const t1 = !allowOverflow && "overflow-hidden";
  let t2;
  if ($[4] !== t1) {
    t2 = classNames(t1);
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = !loop;
  let t4;
  if ($[6] !== animateHeight || $[7] !== autoHeight || $[8] !== className || $[9] !== t3) {
    t4 = classNames("flex", {
      "*:last:!mr-0": t3,
      "items-start": autoHeight,
      "transition-height duration-200": animateHeight
    }, className);
    $[6] = animateHeight;
    $[7] = autoHeight;
    $[8] = className;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props || $[12] !== t4) {
    t5 = <div className={t4} {...props} />;
    $[11] = props;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== carouselRef || $[15] !== t2 || $[16] !== t5) {
    t6 = <div className={t2} ref={carouselRef}>{t5}</div>;
    $[14] = carouselRef;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp2(ctx) {
  return [ctx?.autoHeight, ctx?.animateHeight, ctx?.carouselRef, ctx?.options?.loop];
}
export function CarouselItem(t0) {
  const $ = _c(12);
  let className;
  let props;
  let style;
  if ($[0] !== t0) {
    ({
      className,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = style;
  } else {
    className = $[1];
    props = $[2];
    style = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("min-w-0 shrink-0 grow-0 basis-full pl-4", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== style) {
    t2 = {
      transform: "translate3d(0, 0, 0)",
      ...style
    };
    $[6] = style;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2) {
    t3 = <Block aria-roledescription="slide" className={t1} style={t2} {...props} role="group" />;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export { Carousel };
const useCarousel = useEmblaCarousel;
export { useCarousel };